import { default as _91_46_46_46slug_93XDjAndoEVYMeta } from "/home/runner/work/grove-web/grove-web/pages/[...slug].vue?macro=true";
import { default as _91slug_93LO4mCRzse4Meta } from "/home/runner/work/grove-web/grove-web/pages/blog/[slug].vue?macro=true";
import { default as blogFJuEywsORUMeta } from "/home/runner/work/grove-web/grove-web/pages/blog.vue?macro=true";
import { default as _91slug_93yZoDBjH8clMeta } from "/home/runner/work/grove-web/grove-web/pages/g/[slug].vue?macro=true";
import { default as indexSRAKe8nobwMeta } from "/home/runner/work/grove-web/grove-web/pages/index.vue?macro=true";
import { default as _91slug_93pElYesHTTEMeta } from "~/pages/g/[slug].vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93XDjAndoEVYMeta?.name ?? "slug",
    path: _91_46_46_46slug_93XDjAndoEVYMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93XDjAndoEVYMeta || {},
    alias: _91_46_46_46slug_93XDjAndoEVYMeta?.alias || [],
    redirect: _91_46_46_46slug_93XDjAndoEVYMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: blogFJuEywsORUMeta?.name ?? "blog",
    path: blogFJuEywsORUMeta?.path ?? "/blog",
    meta: blogFJuEywsORUMeta || {},
    alias: blogFJuEywsORUMeta?.alias || [],
    redirect: blogFJuEywsORUMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/blog.vue").then(m => m.default || m),
    children: [
  {
    name: _91slug_93LO4mCRzse4Meta?.name ?? "blog-slug",
    path: _91slug_93LO4mCRzse4Meta?.path ?? ":slug()",
    meta: _91slug_93LO4mCRzse4Meta || {},
    alias: _91slug_93LO4mCRzse4Meta?.alias || [],
    redirect: _91slug_93LO4mCRzse4Meta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/blog/[slug].vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91slug_93yZoDBjH8clMeta?.name ?? "g-slug",
    path: _91slug_93yZoDBjH8clMeta?.path ?? "/g/:slug()",
    meta: _91slug_93yZoDBjH8clMeta || {},
    alias: _91slug_93yZoDBjH8clMeta?.alias || [],
    redirect: _91slug_93yZoDBjH8clMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/g/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexSRAKe8nobwMeta?.name ?? "index",
    path: indexSRAKe8nobwMeta?.path ?? "/",
    meta: indexSRAKe8nobwMeta || {},
    alias: indexSRAKe8nobwMeta?.alias || [],
    redirect: indexSRAKe8nobwMeta?.redirect,
    component: () => import("/home/runner/work/grove-web/grove-web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93pElYesHTTEMeta?.name ?? undefined,
    path: _91slug_93pElYesHTTEMeta?.path ?? "/beyondplastic",
    meta: _91slug_93pElYesHTTEMeta || {},
    alias: _91slug_93pElYesHTTEMeta?.alias || [],
    redirect: _91slug_93pElYesHTTEMeta?.redirect,
    component: () => import("~/pages/g/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93pElYesHTTEMeta?.name ?? undefined,
    path: _91slug_93pElYesHTTEMeta?.path ?? "/how-grove-works",
    meta: _91slug_93pElYesHTTEMeta || {},
    alias: _91slug_93pElYesHTTEMeta?.alias || [],
    redirect: _91slug_93pElYesHTTEMeta?.redirect,
    component: () => import("~/pages/g/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93pElYesHTTEMeta?.name ?? undefined,
    path: _91slug_93pElYesHTTEMeta?.path ?? "/paper",
    meta: _91slug_93pElYesHTTEMeta || {},
    alias: _91slug_93pElYesHTTEMeta?.alias || [],
    redirect: _91slug_93pElYesHTTEMeta?.redirect,
    component: () => import("~/pages/g/[slug].vue").then(m => m.default || m)
  }
]